import React, { forwardRef } from 'react';

// Constants
import ToolbarConfig from '../../Toolbar/toolbar.config';

// Components
import Control from '../Control/Control';

type Props = {
  block: string;
  isEmojiDropdownOpen: boolean;
  handleOpenEmojiMartDropdownChange: Function;
};

type ForwardedRef = {
  current: HTMLButtonElement;
};

const Emoji = forwardRef(
  ({ block, isEmojiDropdownOpen, handleOpenEmojiMartDropdownChange }: Props, ref: ForwardedRef) => {
    const config = ToolbarConfig.find(item => item.block === block);

    const handleClick = () => {
      handleOpenEmojiMartDropdownChange(!isEmojiDropdownOpen);
    };

    return (
      <Control key={config.style} icon={config.icon} onClick={handleClick} ref={ref} active={isEmojiDropdownOpen} />
    );
  }
);

export default Emoji;
